import { observable, decorate } from 'mobx'

class Store {
	online = true

	toArray(_observable) {
		return JSON.parse(JSON.stringify(_observable))
	}
}

// apply mobx for store variables to be use in react components
decorate(Store, {
	online: observable,
})

// for debugging purposes
const store = window.app = new Store()

export default store